import { MessageType } from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { useSummaryInformationMessageOptions } from './AiAssistantMainMenuTileItemSummaryInformation.hooks';
import { StyledMessage } from './AiAssistantMainMenuTileItemSummaryInformation.styled';

const t = translationKeys.mainMenuTileItem.summaryModal;

export const AiAssistantMainMenuTileItemSummaryInformation = (): JSX.Element => {
   const options = useSummaryInformationMessageOptions();

   return (
      <StyledMessage
         testId={'info'}
         type={MessageType.INFORMATIVE}
         label={t.verifyContentInfo}
         displayIndicator
         options={options}
      />
   );
};
